import $ from 'jquery';
import { debounce } from '../utils/functions';
import { reloadScriptAccordion } from '../components/accordion';

const faqsList = (faqsEl) => {
    const filter = {
        search: '',
        category: -1,
    };

    bindFaqFilter(faqsEl, filter);
};

const bindFaqFilter = (element, filter) => {
    element.on(
        'input',
        "input[name='faq_search']",
        debounce(function () {
            filter.search = $(this).val();
            reRenderFaqs(element, filter);
        })
    );

    element.on('change', "select[name='faqs-categories']", function () {
        filter.category = $(this).val();
        reRenderFaqs(element, filter);
    });

    element.on('click', "button[name='remove-faq-filter']", function () {
        filter.search = '';
        filter.category = -1;

        const $thisEl = $(this);
        $thisEl.closest('.block-filter').find("select[name='faqs-categories']").val('-1');
        $thisEl.closest('.block-filter').find("input[name='faq_search']").val('');

        reRenderFaqs(element, filter);
    });
};

const reRenderFaqs = async (element, filter) => {
    const data = await getFaqs(filter);
    element.find('.faq__content').html(data.html);

    reloadScriptAccordion();
};

const getFaqs = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + `/wp-json/opzp/v1/faq/html`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export const reloadScriptFaqs = () => {
    const $faqsEl = $('.faq');

    if ($faqsEl.length > 0) {
        $faqsEl.each(function () {
            faqsList($(this));
        });
    }
};
reloadScriptFaqs();
